<template>
  <tr>
    <td class="text-center" scope="row">{{ report.timestamp | moment('HH:mm') }}น.</td>
    <td>
      <select name="district" v-model="report.districtid" class="form-control">
        <option v-for="(district, index) in districts" :key="index" :value="district.id">{{
          district.district
        }}</option>
      </select>
    </td>
    <td>
      <select name="priority" v-model="report.priority" class="form-control">
        <option v-for="(priority, index) in priorities" :key="index" :value="priority.id">{{
          priority.name
        }}</option>
      </select>
    </td>
    <td>{{ report.message }}</td>
    <td>{{ report.reportby }}</td>
    <td>
      <button class="btn btn-secondary" @click="updateReport">Update</button>
      <button class="btn btn-danger" @click="deleteReport">Delete</button>
    </td>
  </tr>
</template>

<script>
import axios from 'axios'
import config from '@/config'

export default {
  data: function() {
    return {
      priorities: config.reporter.priority,
      districts: config.reporter.districts
    }
  },
  props: ['report', 'pageid', 'problemid'],
  methods: {
    deleteReport: function() {
      let vm = this
      let report = vm.report
      vm.$store.dispatch('loading')
      axios.defaults.headers.common = {
        AUTHORIZATION: this.$store.getters.securityToken
      }
      axios
        .delete(config.serverUrl + 'problemreport?id=' + report.id + '&pageid=' + vm.pageid)
        .then(response => {
          // JSON responses are automatically parsed.
          var response = response.data
          if (response.responsecode == 200) {
            // console.log(response)

            vm.$emit('onDelete', vm.problemid)
          } else if (response.responsecode == 400) {
            let message = response.reason ? response.reason : ''
            var isFacebook = vm.$store.state.isFacebook
            vm.$store.dispatch('logout', {
              error: { code: response.responsecode, message: message }
            })
            if (
              vm.$router.history.current.name != 'login' ||
              vm.$router.history.current.name != 'nigol'
            ) {
              if (isFacebook) {
                vm.$router.push('/login')
              } else {
                vm.$router.push('/nigol')
              }
            }
          } else {
          }
          vm.$store.dispatch('loading')
        })
        .catch(e => {
          console.error(e)
          // this.errors.push(e)
          vm.$store.dispatch('loading')
        })
    },
    updateReport: function() {
      let vm = this
      let report = vm.report
      vm.$store.dispatch('loading')
      axios.defaults.headers.common = {
        AUTHORIZATION: this.$store.getters.securityToken
      }
      axios
        .put(config.serverUrl + 'problemreport?id=' + report.id + '&pageid=' + vm.pageid, report)
        .then(response => {
          // JSON responses are automatically parsed.
          var response = response.data
          if (response.responsecode == 200) {
            // this.reporterlist = response.data
            // problemid
            // console.log(response)
          } else if (response.responsecode == 400) {
            let message = response.reason ? response.reason : ''
            var isFacebook = vm.$store.state.isFacebook
            vm.$store.dispatch('logout', {
              error: { code: response.responsecode, message: message }
            })
            if (
              vm.$router.history.current.name != 'login' ||
              vm.$router.history.current.name != 'nigol'
            ) {
              if (isFacebook) {
                vm.$router.push('/login')
              } else {
                vm.$router.push('/nigol')
              }
            }
          } else {
          }
          vm.$store.dispatch('loading')
        })
        .catch(e => {
          console.error(e)
          // this.errors.push(e)
          vm.$store.dispatch('loading')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/reporter/reporter-list-item.vue